export default class HelpScout {
    constructor($translate, $filter, $rootScope, $transitions, $timeout) {
        this._translator = $filter('translate');
        this._timeout = $timeout;
        this._rootScope = $rootScope;
        this._rootScope.$on('event:beacon.reInit', () => {
            this.initBeacon();
        });
        this._rootScope.$on('event:auth.loginRequired', () => {
            this.logOutFromBeacon()
        });

        $transitions.onStart({}, () => {
            this.triggerArticleSuggest();
        });
    }

    getConfigs() {
        return {
            color: '#05cc87',
            display: {
                style: 'icon',
                iconImage: 'question'
            },
            labels: {
                answer: this._translator('BEACON:ANSWER'),
                ask: this._translator('BEACON:ASK'),
                searchLabel: this._translator('BEACON:SEARCH_LABEL'),
                tryBroaderTerm: this._translator('BEACON:TRY_A_BROADER_TERM_OR'),
                firstAFewQuestions: this._translator('BEACON:FIRST_FEW_QUESTIONS'),
                relatedArticles: this._translator('BEACON:RELATED_ARTICLES'),
                lastUpdated: this._translator('BEACON:LAST_UPDATED'),
                next: this._translator('BEACON:NEXT'),
                history: this._translator('BEACON:HISTORY'),
                tryAgain: this._translator('BEACON:TRY_AGAIN'),
                docsSearchEmptyText: this._translator('BEACON:DOCS_SEARCH_EMPTY_TEXT'),
                docsSearchErrorText: this._translator('BEACON:DOCS_SEARCH_ERROR_TEXT'),
                docsArticleErrorText: this._translator('BEACON:DOCS_ARTICLE_ERROR_TEXT'),
                nothingFound: this._translator('BEACON:NOTHING_FOUND'),
                cantFindAnswer: this._translator('BEACON:CANT_FOUND_ANSWER'),
                aDay: this._translator('BEACON:A_DAY'),
                aFewHours: this._translator('BEACON:A_FEW_HOURS'),
                previousMessages: this._translator('BEACON:PREVIOUS_MESSAGES'),
                getInTouch: this._translator('BEACON:GET_IN_TOUCH'),
                suggestedForYou: this._translator('BEACON:SUGGESTED_FOR_YOU'),
                sendAMessage: this._translator('BEACON:FORM:SEND_A_MESSAGE'),
                sendMessage: this._translator('BEACON:FORM:SEND_MESSAGE'),
                howCanWeHelp: this._translator('BEACON:FORM:HOW_CAN_WE_HELP'),
                responseTime: this._translator('BEACON:FORM:RESPONSE_TIME'),
                weUsuallyRespondIn: this._translator('BEACON:FORM:RESPONSE_TIME'),
                aFewMinutes: this._translator('BEACON:FORM:A_FEW_MINUTES'),
                messageSubmitLabel: this._translator('BEACON:FORM:MESSAGE_SUBMIT_LABEL'),
                nameLabel: this._translator('BEACON:FORM:NAME_LABEL'),
                emailLabel: this._translator('BEACON:FORM:EMAIL_LABEL'),
                subjectLabel: this._translator('BEACON:FORM:SUBJECT_LABEL'),
                messageLabel: this._translator('BEACON:FORM:MESSAGE_LABEL'),
                emailValidationLabel: this._translator('BEACON:FORM:EMAIL_VALIDATION_LABEL'),
                uploadAnImage: this._translator('BEACON:FORM:UPLOAD_AN_IMAGE'),
                attachAFile: this._translator('BEACON:FORM:ATTACH_A_FILE'),
                attachmentErrorText: this._translator('BEACON:FORM:ATTACHMENT_ERROR_TEXT'),
                attachmentSizeErrorText: this._translator('BEACON:FORM:ATTACHMENT_SIZE_ERROR_TEXT'),
                customFieldsValidationLabel: this._translator('BEACON:FORM:CUSTOM_FIELD_VALIDATION_LABEL'),
                weAreOnIt: this._translator('BEACON:FORM:WE_ARE_ON_IT'),
                messageConfirmationText: this._translator('BEACON:FORM:MESSAGE_CONFIRMATION_TEXT'),
                viewAndUpdateMessage: this._translator('BEACON:FORM:VIEW_AND_UPDATE_MESSAGE_IN'),
                addYourMessageHere: this._translator('BEACON:FORM:ADD_YOUR_MESSAGE_HERE'),
                you: this._translator('BEACON:FORM:YOU'),
                received: this._translator('BEACON:FORM:RECEIVED'),
                waitingForAnAnswer: this._translator('BEACON:FORM:WAITING_FOR_AN_ANSWER'),
                addReply: this._translator('BEACON:FORM:ADD_A_REPLY'),
                endChat: this._translator('BEACON:FORM:END_CHAT'),
                ending: this._translator('BEACON:FORM:ENDING'),
                continueEditing: this._translator('BEACON:FORM:CONTINUE_EDITING'),
                replyErrorText: this._translator('BEACON:FORM:REPLY_ERROR_TEXT'),
                chatHeadingTitle: this._translator('BEACON:FORM:CHAT_HEADING_TITLE'),
                defaultMessageErrorText: this._translator('BEACON:FORM:DEFAULT_MESSAGE_ERROR_TEXT'),
                previousMessageErrorText: this._translator('BEACON:FORM:PREVIOUS_MESSAGES_ERROR_TEXT'),
                previousMessagesErrorText: this._translator('BEACON:FORM:PREVIOUS_MESSAGE_ERROR_TEXT'),
                chatHeadingSublabel: this._translator('BEACON:FORM:CHAT_HEADING_SUB_LABEL'),
                chatbotPromptEmail: this._translator('BEACON:FORM:CHAT_BOT_PROMPT_EMAIL'),
                chatbotConfirmationMessage: this._translator('BEACON:FORM:CHAT_BOT_CONFIRMATION_MESSAGE'),
                chatbotGreet: this._translator('BEACON:FORM:CHAT_BOT_GREAT'),
                chatEndCalloutHeading: this._translator('BEACON:FORM:CHAT_END_CALL_OUT_HEADING'),
                chatEndCalloutMessage: this._translator('BEACON:FORM:CHAT_END_CALL_OUT_MESSAGE'),
                chatEndCalloutLink: this._translator('BEACON:FORM:CHAT_END_CALL_OUT_LINK')
            }
        }
    }

    triggerArticleSuggest() {
        this._timeout(() => {
            if (Beacon) Beacon('suggest', []);
        });
    }

    initBeacon() {
        if (Beacon) Beacon('config', this.getConfigs());
    }

    closeBeacon() {
        if (Beacon) Beacon('close');
    }

    logOutFromBeacon() {
        if (Beacon) Beacon('logout', {endActiveChat: true});
    }
}

HelpScout.$inject = ['$translate', '$filter', '$rootScope', '$transitions', '$timeout'];
